<template lang="html">
  <div
    v-if="interview"
    class="vid-int-start"
    :class="{
      tightContainer: isStartOrEndPage,
      'min-width': !isStartOrEndPage,
      'no-padding': badBrowser
    }"
  >
    <div class="logo-wrapper">
      <img v-if="logo" class="vid-int__logoImage" alt="company-logo" :src="logo" />
    </div>

    <bad-browser v-if="badBrowser" :locale="locale" />

    <template v-else>
      <interview-end v-if="isFinishedStage" :candidate="candidate" class="vid-int-start" />

      <interview-start
        v-else-if="!isAgreedToInterview"
        :company-name="whichCompanyNameIs"
        :user-name="whichUserNameIs"
        :vacancy-name="vacancy ? vacancy.name : null"
        :vacancy-description="vacancy ? vacancy.description : defaultDescription"
        :vacancy-video="vacancy ? vacancy.video_link : null"
        :token="token"
        :from-registration="fromRegistration"
        :disable="isDisable"
        @agreed="agreed"
      />

      <div v-else-if="isTestStage" class="inside-section">
        <interview-test :interview="interview" @complete="completeInterviewTest" />
      </div>

      <div v-else-if="isVideointerviewStage" class="vid-int-start">
        <videointerview-scene :interview="interview" />
      </div>
    </template>
  </div>
</template>

<script>
  import InterviewTest from '@/components/interview/test/Scene';
  import VideointerviewScene from '@/components/interview/videointerview/Scene';
  import InterviewStart from '@/components/interview/Start';
  import InterviewEnd from '@/components/interview/End';
  import BadBrowser from '@/components/interview/BadBrowser';
  import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
  import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';

  import isMobile from 'ismobilejs';

  const HTTP_FORBIDDEN = 403;

  export default {
    name: 'InterviewSceneContent',

    components: {
      InterviewTest,
      VideointerviewScene,
      InterviewStart,
      InterviewEnd,
      BadBrowser
    },

    mixins: [IEBrowserDetector, SafariBrowserDetector],

    props: {
      interview: {
        type: Object,
        default: null
      },

      vacancy: {
        type: Object,
        default: null
      },

      loading: {
        type: Boolean,
        default: false
      },

      fetch: {
        type: Function,
        default: () => {}
      },

      fromRegistration: {
        type: Boolean,
        default: false
      },

      error: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        isAgreedToInterview: false,
        isMobile: isMobile.any
      };
    },

    computed: {
      // isNewWay() {
      //   return this.$store.getters['services/isNewWay'];
      // },

      defaultDescription() {
        return this.$tr(`videoInterview.start.default.description`);
      },

      whichCompanyNameIs() {
        return this.interview.company
          ? this.interview.company.name
          : this.$tr(`videoInterview.start.default.companyName`);
      },

      whichUserNameIs() {
        return this.interview.candidate
          ? this.interview.candidate.name
          : this.$tr(`videoInterview.start.default.username`);
      },

      candidate() {
        return this.interview ? this.interview.candidate : null;
      },

      logo() {
        return this.interview.company ? this.interview.company.logo : null;
      },

      token() {
        return this.interview.token;
      },

      stageId() {
        return this.interview && this.interview.stage ? this.interview.stage.id : null;
      },

      isStartOrEndPage() {
        return this.isFinishedStage || !this.isAgreedToInterview;
      },

      isVideointerviewStage() {
        return ['new', 'videointerview'].indexOf(this.stageId) !== -1;
      },

      isFinishedStage() {
        return this.stageId === 'finished';
      },

      isTestStage() {
        return this.stageId === 'test';
      },

      isIntegrationStage() {
        return this.stageId === 'integration';
      },

      isDisable() {
        return this.error && this.error.status === HTTP_FORBIDDEN;
      },

      badBrowser() {
        if (this.isIE11OrOlder || this.defineRecordingFlow === 'notallowed') {
          return true;
        }

        return false;
      },

      locale() {
        const lang = this.vacancy ? this.vacancy.language : null;

        return lang ? lang.code : null;
      }
    },

    watch: {
      isStartOrEndPage(val) {
        this.$store.commit('interview/videointerview/isStartOrEndPageChange', val);
      }
    },

    beforeMount() {
      this.$store.commit('interview/videointerview/isStartOrEndPageChange', this.isStartOrEndPage);
    },

    methods: {
      agreed() {
        this.isAgreedToInterview = true;
      },

      // @TODO do not refetch, use data from test submit to switch stage
      async completeInterviewTest() {
        // fetch here is bacause after test end, it is possible to show message with time limit text
        await this.fetch();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .vid-int__logoImage {
    max-height: 50px;
    display: inline-block;
  }

  .vid-int-start {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    background: white;

    &.tightContainer {
      max-width: 800px;
      padding: 0 88px;
      box-sizing: border-box;

      &.no-padding {
        padding: 0;
      }
    }

    &.min-width {
      min-width: 960px;
    }

    &.no-padding {
      padding: 0;
    }
  }

  .logo-wrapper {
    margin: 10px auto;
    min-height: 50px;
  }

  @media (max-width: 768px) {
    .vid-int-start.tightContainer {
      max-width: 800px;
      padding: 0 35px;

      &.no-padding {
        padding: 0;
      }
    }
  }
</style>
